
import {Component, Prop, PropSync, Vue} from "vue-property-decorator";
import {Store} from "@/enums/Store";
import {ValidationMode} from "@/enums/ValidationMode";
import {namespace} from 'vuex-class'
import {ValidationProvider} from 'vee-validate'

const APP = namespace(Store.APP);

@Component({
  components: {
    ValidationProvider
  }
})
export default class FormBase extends Vue {
  @PropSync('data') value?: number | string | boolean;
  @Prop() rules?: string | any;
  @Prop({default: false}) skipIfEmpty!: boolean;
  @Prop({default: false}) disabled!: boolean;
  @Prop({default: true}) large!: boolean;
  @Prop({default: true}) showValidationState!: boolean;
  @Prop() link?: string;
  @Prop() linkText?: string;
  @Prop({default: ValidationMode.Aggressive}) mode!: ValidationMode;

  @APP.Mutation('ADD_ERROR') addError!: (error: Error) => void;

  showIsValid() {
    if (!this.showValidationState || !this.$refs.validator) {
      return false;
    }
    return (this.$refs.validator as any).flags.validated && (this.$refs.validator as any).flags.valid
  }

  showIsInvalid() {
    if (!this.showValidationState || !this.$refs.validator) {
      return false;
    }
    return (this.$refs.validator as any).flags.validated && (this.$refs.validator as any).flags.invalid
  }

  async validate(silent = false) {
    if (typeof (this.$refs.validator as any).validate === 'function') {
      try {
        if (silent) {
          const result = await (this.$refs.validator as any).validateSilent();
          return result.valid
        }

        const result = await (this.$refs.validator as any).validate();
        return result.valid
      } catch (e) {
        this.addError(e);
      }
    }
  }

  reset() {
    if (typeof (this.$refs.validator as any).reset === 'function') {
      (this.$refs.validator as any).reset();
    }
  }
}
